import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { PropertiesPage } from '../../pages/properties/properties';
import { HomePage } from '../../pages/home/home';
import { AuthService } from '../../services/auth.service';
import { UserModel } from '../../models/user.model';
import { UserStore } from '../../stores/user.store';
import { ConfigStore } from '../../stores/config.store';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

    public loginData = {
        agenzia: "",
        username: "",
        password: "",
        ricordami: true
    }

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private alertCtrl: AlertController,
        private auth: AuthService,
        private userStore: UserStore,
        private config: ConfigStore) {

        /* userStore.load();

        if (userStore.data)
        {
            this.loginData.agenzia = userStore.data.Agenzia;
            this.loginData.username = userStore.data.Username;            
        } */
    }

    ionViewDidLoad() {
        // console.log('ionViewDidLoad Login');

        this.userStore.load();

        if (this.userStore.data) {
            this.loginData.agenzia = this.userStore.data.Agenzia;
            this.loginData.username = this.userStore.data.Username;
        }
    }

    login() {
        this.auth.login(this.loginData.agenzia, this.loginData.username, this.loginData.password, this.loginData.ricordami)
            .subscribe(
                data => {
                    // console.log('[LoginPage] login | data: ');
                    // console.log(data);

                    // Salva i dati dell'utente nello user.store
                    let user: UserModel = new UserModel();                    

                    user.Id = data.Id;
                    user.Agenzia = this.loginData.agenzia;
                    user.Username = this.loginData.username;
                    user.Nome = data.Nome;
                    user.Tel = data.Tel;
                    user.Cell = data.Cell;
                    user.Email = data.Email;

                    this.userStore.data = user;
                    this.userStore.save();

                    // ToDo: aprire la pagina dell'elenco immobili in maniera pi� strutturata...   

                    if (this.config.data.lastVersionInfo != this.config.currentVersion)
                    {
                        this.navCtrl.setRoot(HomePage);
                    } 
                    else
                    {
                        let navParams = {
                            title: 'Residenziali',
                            category: 'R'
                        }

                        this.navCtrl.setRoot(PropertiesPage, navParams);
                    }                                         
                },
                err => {

                    let message = 'Impossibile effettuare il login.';

                    switch (err.status)
                    {                        
                        case 403: message = 'Credenziali errate.'; break;
                        case 500: message = 'Impossibile stabilire una connessione al server.'; break;
                    }                    
                    
                    this.showError(message);
                });
    }

    showError(message: string)
    {
        let alert = this.alertCtrl.create({
            title: 'Errore',
            subTitle: message,
            buttons: ['OK']
        });
        alert.present(); 
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts